import React, { useEffect, useReducer } from "react";
import { hospitalActions } from "../actions";
import { 
  hospitalStatus as hospitalStatusReducer,
  initialStatus as initialHospitalStatus,
  nedocsReducer,
  initialNedocs,
} from "../reducers";
import { CardStatusProntoSoccorso } from "../components/CardStatusProntoSoccorso";
import { useInternationalization } from "../hooks/useInternationalization";
import { Header } from "../components/Header";
import { Loader } from "../components/Loader";
import { useIntl } from "react-intl";

export const StatusProntoSoccorso = ({ history }) => {
  const [hospitalStatus, updateHospitalStatus] = useReducer(
    hospitalStatusReducer,
    initialHospitalStatus
  );
  const [nedocsStatus, updateNedocs] = useReducer(nedocsReducer, initialNedocs);

  const { locale } = useInternationalization();
  const intl = useIntl();

  useEffect(() => {
    hospitalActions.hospitalNedocs("20700", updateNedocs, intl);
    hospitalActions.statusProntoSoccorso("20700", locale, updateHospitalStatus, intl);
  }, [locale]);

  return (
    <React.Fragment>
      <Header history={history} />
      {
        (() => {
          if (hospitalStatus.pristine || nedocsStatus.pristine) {
            return null;
          }
  
          if (hospitalStatus.loading || nedocsStatus.loading) {
            return <Loader />;
          }
  
          return (
            <CardStatusProntoSoccorso
              hospitalState={hospitalStatus}
              nedocsValue={nedocsStatus.nedocs.value}
            />
          );
        })()
      }
    </React.Fragment>
  );
};
